// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactHubModal-cls1___ff8cfafd8d51a363f21","cls2":"ImpactHubModal-cls2___663a57858a3f3213e29 ImpactHubModal-cls1___ff8cfafd8d51a363f21"};